









































































































































































import useArchiveChat from "@/composables/v3/useArchiveChat";
import useAssignChat from "@/composables/v3/useAssignChat";
import { mobilePluginBarActive, mqShallShowSidebarLeft } from "@/composables/v3/useUx";
import { useChannelsStore } from "@/store/useChannelsStore";
import { useChatsStore } from "@/store/useChatsStore";
import { useContactsStore } from "@/store/useContactsStore";
import { useDownloadAttachmentsStore } from "@/store/useDownloadAttachmentsStore";
import { resolvePlatformIconSvgSrc, resolvePriorityVariant } from "@/utils/channels";
import { resolveInitials } from "@/utils/users";
import Assign from "@/views/modules/messaging-inbox/navbar/components/assign.vue";
import AssignMobile from "@/views/modules/messaging-inbox/navbar/components/assignMobile.vue";
import FileDownload from "@/views/modules/messaging-inbox/navbar/components/fileDownload.vue";
import FileDownloadMobile from "@/views/modules/messaging-inbox/navbar/components/fileDownloadMobile.vue";
import Contact from "@/views/modules/messaging-inbox/sidebar-right/contact.vue";
import { defineComponent } from "@vue/composition-api";
import { BAvatar, BButton, BDropdown, BDropdownItem, BImg, BSpinner, VBTooltip } from "bootstrap-vue";
import { storeToRefs } from "pinia";

export default defineComponent({
    components: {
        Assign,
        AssignMobile,
        BAvatar,
        BButton,
        BDropdown,
        BDropdownItem,
        BImg,
        BSpinner,
        Contact,
        FileDownload,
        FileDownloadMobile,
    },
    directives: {
        "b-tooltip": VBTooltip,
    },
    setup() {
        const chatsStore = useChatsStore();
        const channelsStore = useChannelsStore();
        const contactsStore = useContactsStore();

        const { isArchivePending, archive, unarchive } = useArchiveChat();

        const toggleArchive = (): void => {
            if (!chatsStore.activeChat) {
                return;
            }

            mqShallShowSidebarLeft.value = true;

            if (chatsStore.activeChat.chat.status === "closed") {
                unarchive(chatsStore.activeChat.chat);
                return;
            }

            archive(chatsStore.activeChat.chat);
        };

        const { hasDownloads } = storeToRefs(useDownloadAttachmentsStore());
        const { assignToMe } = useAssignChat();
        return {
            hasDownloads,
            assignToMe,
            channelsStore,
            chatsStore,
            contactsStore,
            isArchivePending,
            mobilePluginBarActive,
            mqShallShowSidebarLeft,
            resolveInitials,
            resolvePlatformIconSvgSrc,
            resolvePriorityVariant,
            toggleArchive,
        };
    },
});
